module.exports = __webpack_public_path__ + "lp/img/speaker_icn-darkgray.04846a6f.svg";